import * as _ from 'lodash';

export default class EntitySettings {

  /**
   * @type {string}
   */
  #settingsOptionName;

  /**
   * @type {function}
   */
  #settings;

  /**
   * @param {string} settingsOptionName
   * @param {function} settings
   */
  constructor(settingsOptionName, settings) {
    this.#settingsOptionName = settingsOptionName;
    this.#settings = settings;
  }

  /**
   * @return {{}}
   */
  get data() {
    return this.#settings()[this.#settingsOptionName];
  }

  /**
   * @param {number} id
   * @return {null|{config, date_start, date_stop, is_active: boolean, discount: {value: number|null, type: string}}}
   */
  getSettingsById(id) {
    const data = this.data[id];
    if (typeof data === 'undefined') {
      return null;
    }

    return _.cloneDeep(data);
  }
}